import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { SafeResourceUrl } from "@angular/platform-browser";

export interface EmbedPreviewDialogData {
  title: string;
  previewUrl: SafeResourceUrl;
  width: number;
  height: number;
  flowData?: any;
}

@Component({
  selector: "app-embed-preview-dialog",
  templateUrl: "./embed-preview-dialog.component.html",
  styleUrls: ["./embed-preview-dialog.component.scss"],
})
export class EmbedPreviewDialogComponent implements OnInit, OnDestroy {
  isLoading = true;
  private loadTimeoutId: ReturnType<typeof setTimeout> | null = null;

  constructor(
    public dialogRef: MatDialogRef<EmbedPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EmbedPreviewDialogData
  ) {}

  ngOnInit(): void {
    this.loadTimeoutId = setTimeout(() => {
      this.isLoading = false;
    }, 15000);
  }

  ngOnDestroy(): void {
    if (this.loadTimeoutId) {
      clearTimeout(this.loadTimeoutId);
    }
  }

  onIframeLoad(): void {
    this.isLoading = false;
    if (this.loadTimeoutId) {
      clearTimeout(this.loadTimeoutId);
      this.loadTimeoutId = null;
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
